define([
    "./monitoringIntegrationModule"
], function (module) {

    return module.service("monitoringIntegrationService", ["monitoringIntegrationUrls", "$http", function (monitoringIntegrationUrls, $http) {
        this.findDefault = () => $http.get(monitoringIntegrationUrls.baseUrl).then(response => response.data);
        this.save = (config) => $http.post(monitoringIntegrationUrls.baseUrl, config).then(response => response.data);
    }])
})